import { FC } from "react";
import pluralize from "pluralize";
import { get, words } from "lodash";
import LinkWrapper from "./LinkWrapper";
import { Grid, Skeleton, Typography } from "@mui/material";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import { CheckCircle } from "@mui/icons-material";
import Dot from "../../../../icons/Dot";

export interface EncounterEntryProps {
  entries?: any[];
  type: string;
  onEntryClick?: (i: any) => void;
  readonly?: boolean;
  textProperty?: string;
}

const EncounterEntryComponent: FC<EncounterEntryProps> = ({
  entries,
  type,
  onEntryClick,
  children,
  readonly,
  textProperty,
}) => {
  if (entries?.length) {
    return (
      <>
        {entries.map((entry, i) => (
          <Grid
            key={`${type}-${i}`}
            item
            xs={12}
            style={{
              cursor: "pointer",
              marginBottom: i < entries.length - 1 ? 8 : 0,
            }}
          >
            {
              <LinkWrapper
                wrapWithLink={typeof readonly !== "boolean" || !readonly}
                onClick={onEntryClick ? () => onEntryClick(entry.id) : () => {}}
              >
                <Grid container direction="row">
                  <Grid item xs={1} style={{ maxWidth: 25 }}>
                    {entry.final ? (
                      <CheckCircle sx={{ color: "green" }} />
                    ) : (
                      <Dot />
                    )}
                  </Grid>
                  <Grid item xs={11}>
                    <Typography variant="body2">
                      &nbsp;
                      {textProperty ? get(entry, textProperty) : entry.text}
                    </Typography>
                  </Grid>
                </Grid>
              </LinkWrapper>
            }
          </Grid>
        ))}
      </>
    );
  } else if (children) {
    return <>{children}</>;
  } else {
    return (
      <Typography variant="body2">
        No {words(pluralize(type)).join(" ")} recorded.
      </Typography>
    );
  }
};

const EncounterEntries: FC<EncounterEntryProps> = ({
  entries,
  type,
  onEntryClick,
  children,
  readonly,
  textProperty,
}) => {
  const [loading] = useFullPageLoader();

  return (
    <Grid container>
      {!loading ? (
        <EncounterEntryComponent
          entries={entries}
          type={type}
          onEntryClick={onEntryClick}
          readonly={readonly}
          textProperty={textProperty}
        >
          {children}
        </EncounterEntryComponent>
      ) : (
        <>
          <Skeleton />
          <Skeleton width="50%" />
        </>
      )}
    </Grid>
  );
};

export default EncounterEntries;
